<!-- 客户案例分享 -->
<template>
  <div class="case-share-container">
    <roof-search v-if="showNav" :middleContent="false" :rightContent="false"></roof-search>
    <div class="share-list" ref="activity_scroll" @scroll="activityScroll">
      <div class="item" v-for="(item,index) in caseShareList" :key="index" @click="goDetail(item)">
        <div class="cover-img">
          <img :src="cdnUrl+item.img_url" alt="">
        </div>
        <div class="van-multi-ellipsis--l2 title">{{item.title}}</div>
      </div>
    </div>
<!--    <div class="no-data" v-if="caseShareList.length == 0">-->
<!--      <img src="@/assets/img/no-data.png" alt="" class="no-data-img" width="100%">-->
<!--      <p class="hint-text">暂无数据</p>-->
<!--    </div>-->
  </div>
</template>

<script>
import roofSearch from '@/components/roof-search'
import { getExampleList } from '@/api/caseShare'
import { wxShare } from '@/libs/wxjssdk'

export default {
    data () {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            pageSize: 1,
            last_page: '',
            showNav: true,
            caseShareList: []
        }
    },
    components: {
        roofSearch
    },
    activated () {
        this.showNav = true
        this.sharePage()
    },
    deactivated () {
        this.showNav = false
    },
    created () {
        this.getExampleListPort()
    },
    mounted () {
        this.sharePage()
    },
    computed: {
        whetherSignature () {
            return this.$store.state.user.whetherSignature
        }
    },
    watch: {
        whetherSignature (newVAl) {
            if (newVAl === true) {
                this.sharePage()
                // console.log('vuex发生变化了', newVAl)
            }
        }
    },
    methods: {
        sharePage () {
            const params = {
                title: 'Eppendorf 客户案例分享', // 分享标题
                desc: '客户案例分享', // 分享描述
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: window.location.origin + '/eppendorf_single/logo.png' // 分享图标
            }
            wxShare(params)
        },
        activityScroll () {
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 150 // 距离底部距离
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                if (this.pageSize < this.last_page) {
                    this.pageSize++
                    this.getExampleListPort()
                }
                // this.$toast('上拉触底了')
            }
        },
        goDetail (item) {
            this.$router.push(
                {
                    name: 'caseDetail',
                    query: {
                        id: item.id
                    }
                }
            )
        },
        /** 网络请求 **/
        // 获取案例分享列表
        getExampleListPort () {
            this.$toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0
            })
            var params = {
                page: this.pageSize,
                type: 1
            }
            getExampleList(params).then(res => {
                if (res.errCode === 0) {
                    var data = res.data
                    this.last_page = data.last_page
                    var caseShareList = [...this.caseShareList]
                    caseShareList.push(...data.data)
                    this.caseShareList = caseShareList
                } else {
                    this.$toast(res.errMsg)
                }
                this.$toast.clear()
            }).catch(err => {
                console.log('案例分享列表接口失败', err)
                this.$toast('案例分享列表接口失败')
            })
        }
    }
}
</script>

<style lang="scss" scoped>
  .case-share-container {
    position: relative;
    background: #f8f7fc;
    width: 100%;
    height: 100vh;

    .share-list {
      width: 100%;
      height: 100%;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      padding: rem(46) rem(20);

      &:after {
        content: '';
        display: block;
        clear: both;
      }

      .item {
        width: rem(156);
        height: rem(120);
        background: #fff;
        border-radius: 4px;
        margin-top: rem(20);
        display: flex;
        flex-direction: column;

        &:nth-child(odd) {
          float: left;
        }

        &:nth-child(even) {
          float: right;
        }

        .cover-img {
          // height: rem(105);

          img {
            width: 100%;
            height: 100%;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
          }
        }

        .title {
          padding: 0 rem(10);
          color: #2C2C2C;
          font-size: rem(12);
          padding-top: rem(5);
          line-height: rem(18);
        }

      }
    }

    .no-data{
      width: 60%;
      display: block;
      margin: 0 auto;
      margin-top: rem(35);
      text-align: center;
      color: #b1acac;
      font-size: rem(13);
      padding-bottom: rem(10);
      .hint-text{
        margin: rem(10) 0;
      }
    }
  }
</style>
